import { Component, Input, OnInit } from '@angular/core';
import { IRegisterForm } from '../../forms/register-form/register-form.component';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { AccountService } from 'src/app/account/services/account.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { SettingService } from 'src/app/shared/services/setting.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService, IGetPageRegistrationConfigurationResponseModel } from '../../services/auth.service';
import { ILocation, LocationService } from 'src/app/services/location.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
type RegisterStep = 'email' | 'registration' | 'completed';

@Component({
    selector: 'app-register-page',
    templateUrl: './register-page.component.html',
    styleUrls: ['./register-page.component.scss'],
    standalone: false
})
export class RegisterPageComponent implements OnInit {
  @Input() fromDesktopCheckout: boolean = false;
  
  title: string = 'Nav.Register';
  step: RegisterStep = 'email';
  emailCode: IRegisterForm;

  logo!: SafeUrl;

  get emailId() {
    if (this.emailCode)
      return this.emailCode.codeId;
  }

  
  ////////////////////////////////////////////////////////////////////////////////////////////////////////
  // used for the new form registration:
  RegistrationConfigurationData: IGetPageRegistrationConfigurationResponseModel;
  useCustomAPI: boolean = false;
  locations: ILocation[] = [];
  ////////////////////////////////////////////////////////////////////////////////////////////////////////


  constructor(private router: Router,private route: ActivatedRoute,
    private modalCtrl: ModalController,
    private accountService: AccountService,
    private loader: LoaderService,
    public setting: SettingService,
    private sanitizer: DomSanitizer,
    private locationService: LocationService,
    private auth: AuthService,
    private translateService: TranslationService,
    private toastController: ToastController) { }

  ngOnInit() {
    this.getRegistrationConfig(); // collecting registration data here
    this.getLocations();
    if(this.setting.configuration?.logoShortName) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));
    } else if(this.setting.configuration?.logoUrl) {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.configuration?.logoUrl);
    } else {
      this.logo = this.sanitizer.bypassSecurityTrustUrl(null);
    }
    //this.logo = this.sanitizer.bypassSecurityTrustUrl(this.setting.apiUrl("/Menu/GetMenuItemImage?name=" + this.setting.configuration.logoShortName));

    const language = this.route.snapshot.paramMap.get('language');
    if(language)
    {
      if(language === 'en' || language === 'fr')
      { }
      else {
        if(!this.fromDesktopCheckout){
          this.router.navigate(['/auth']);
        }
      }
    }

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }

  onEmailForm(form: IRegisterForm) {
    this.emailCode = form;
    this.step = 'registration';
  }

  async onRegistrationCompleted() {
    if(this.fromDesktopCheckout){
      const loader = await this.loader.create();
      await loader.present();
      this.accountService.generate()
        .pipe(finalize(async () => {
          await loader.dismiss();
        }))
        .subscribe(() => {
          this.modalCtrl.dismiss({
            onLogin: true
          });
        });
      return false;
    } else {
      let toast = await this.toastController.create({
        message: this.translateService.translate("Auth.RegistrationCompletePopup"),
        duration: 7000,
        position: 'bottom'
      });
      await toast.present();
      this.step = 'completed';
      this.router.navigateByUrl('/auth/login');
    }
  }

  notReceivedAnyCode() {
    this.emailCode = null;
    this.step = 'email';
  }


  ////////////////////////////////////////////////////////////////////////////////////////////////////////
  // used for the new registration
  getRegistrationConfig() {
    this.auth.getRegistrationConfiguration().subscribe(config => {
      if(config.success && config.config) {
        this.RegistrationConfigurationData = config;
        this.useCustomAPI = true;
        console.log(config);
      }
    });
  }

  async getLocations() {
    this.locationService.locations().subscribe(locations => {
      this.locations = locations;
    });
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////
}
